import * as Sentry from '@sentry/react';
import type React from 'react';
import { useEffect } from 'react';
import { APP_ENV } from '../../lib/constants.ts';

type Props = {
    children: React.ReactNode | React.ReactNode[];
};

export function SentryProvider({ children }: Props) {
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        if (process.env.NODE_ENV === 'development') {
            return;
        }
        Sentry.setTag('environment', APP_ENV);
    }, []);

    return children;
}
